import th4 from '../../assets/projects_images/TH4.jpg'
import th5 from '../../assets/projects_images/TH5.jpg'
import th6 from '../../assets/projects_images/TH6.jpg'
import th7 from '../../assets/projects_images/TH7.jpg'
import th8 from '../../assets/projects_images/TH8.jpg'
import th9 from '../../assets/projects_images/TH9.jpg'
import th1 from '../../assets/projects_images/TH1.jpg'
import th2 from '../../assets/projects_images/TH2.jpg'
import th3 from '../../assets/projects_images/TH3.jpg'

import youtube from '../../assets/icons/youtube.svg'
import github from '../../assets/icons/github.svg'
import behance from '../../assets/icons/behance.svg'
import atom from '../../assets/icons/atom.svg'


const data_projects = [
    {
        icon: youtube,
        name: 'Introduction to Illustrator',
        image: th1,
        deployed_url: 'https://youtu.be/y1V7KBEugMw',
        github_url: 'https://youtu.be/y1V7KBEugMw',
        category: ['YouTube']
    },

    {
        icon: youtube,
        name: 'Trailer Video: Illustrator',
        image: th2,
        deployed_url: 'https://youtu.be/iXHDAnG2HRg',
        github_url: 'https://youtu.be/iXHDAnG2HRg',
        category: ['YouTube']
    },

    {
        icon: behance,
        name: 'Terrain',
        image: th3,
        deployed_url: 'https://www.behance.net/gallery/107779835/Terrain',
        github_url: 'https://www.behance.net/gallery/107779835/Terrain',
        category: ['Graphics']
    },

    {
        icon: behance,
        name: 'Unity',
        image: th4,
        deployed_url: 'https://www.behance.net/gallery/114202803/UNITY',
        github_url: 'https://www.behance.net/gallery/114202803/UNITY',
        category: ['Graphics']
    },

    {
        icon: github,
        name: 'AI bot',
        image: th5,
        deployed_url: 'https://gitfront.io/r/amlanmukherjee/4c09de6d97e049793a8aae000e78b224dd778216/AI-BOT/',
        github_url: 'https://gitfront.io/r/amlanmukherjee/4c09de6d97e049793a8aae000e78b224dd778216/AI-BOT/',
        category: ['ML']
    },

    {
        icon: behance,
        name: 'Poster Samples - 2020',
        image: th6,
        deployed_url: 'https://www.behance.net/gallery/114186621/Poster-Samples-2020',
        github_url: 'https://www.behance.net/gallery/114186621/Poster-Samples-2020',
        category: ['Graphics']
    },

    {
        icon: github,
        name: 'Cronox - Algo Trading',
        image: th7,
        deployed_url: 'https://gitfront.io/r/amlanmukherjee/3d8af2ac64c11bd06bda55200edb1ed6e3fa1a9c/cronox/',
        github_url: 'https://gitfront.io/r/amlanmukherjee/3d8af2ac64c11bd06bda55200edb1ed6e3fa1a9c/cronox/',
        category: ['ML']
    },

    {
        icon: atom,
        name: 'My Website',
        image: th8,
        deployed_url: '/',
        github_url: '/',
        category: ['Web']
    },

    {
        icon: behance,
        name: 'Gaming-Logo Design',
        image: th9,
        deployed_url: 'https://www.behance.net/gallery/114190387/Gaming-Logo',
        github_url: 'https://www.behance.net/gallery/114190387/Gaming-Logo',
        category: ['Graphics']
    }
]

export default data_projects;